import { heroImage } from "@/mocks/images";
import { site } from "@/mocks/site-data";

export default function Hero() {
  return (
    <section id="inicio" className="relative min-h-[100dvh] overflow-hidden bg-background-50">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Dra. Sâmia Albuquerque — Medicina estética em Fortaleza"
          title="Dra. Sâmia Albuquerque — Medicina estética em Fortaleza"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-black/10" />
        <div className="absolute inset-0 bg-primary-900/15" />
      </div>

      <div className="pointer-events-none absolute inset-0 texture-grain opacity-40" />

      <div className="relative mx-auto flex min-h-[100dvh] w-full max-w-8xl flex-col items-center justify-center px-6 pt-24 pb-16 text-center md:px-8 md:pt-28 md:pb-20">
        <div className="max-w-3xl">
          <h1 className="animate-fade-up font-heading text-5xl font-normal leading-[1.1] tracking-wide text-foreground-50 md:text-7xl lg:text-8xl">
            Dra. Sâmia
            <br />
            Albuquerque
          </h1>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-2 gap-y-1.5 px-2 text-[10px] uppercase tracking-[0.3em] text-accent-300/80 md:gap-x-4 md:text-xs">
            <span>Harmonização facial</span>
            <span className="h-1 w-1 rounded-full bg-accent-500/50" />
            <span>Cuidado da pele</span>
            <span className="h-1 w-1 rounded-full bg-accent-500/50" />
            <span>Nutrologia</span>
            <span className="h-1 w-1 rounded-full bg-accent-500/50" />
            <span>Envelhecimento equilibrado</span>
          </div>

          <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <a
              href={site.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors duration-300 hover:bg-accent-400"
            >
              <i className="ri-whatsapp-line text-base" />
              Agendar minha avaliação
            </a>
            <a
              href="#tratamentos"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-50/25 px-7 py-3.5 text-sm font-semibold text-foreground-50 transition-colors duration-300 hover:border-accent-400 hover:text-accent-200"
            >
              Conhecer os tratamentos
            </a>
          </div>

          <div className="mt-12 flex items-center justify-center gap-3 text-[11px] uppercase tracking-[0.2em] text-foreground-100/50">
            <span>{site.crm}</span>
            <span className="h-3 w-px bg-foreground-50/15" />
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-[8px] text-accent-500" />
              <i className="ri-star-fill text-[8px] text-accent-500" />
              <i className="ri-star-fill text-[8px] text-accent-500" />
              <i className="ri-star-fill text-[8px] text-accent-500" />
              <i className="ri-star-fill text-[8px] text-accent-500" />
            </span>
            <span className="h-3 w-px bg-foreground-50/15" />
            <span>Atendimento em Fortaleza</span>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-foreground-100/40">
          <span>Role para descobrir</span>
          <div className="flex h-10 w-5 items-start justify-center rounded-full border border-foreground-50/15 px-1 pt-1.5">
            <div className="h-2 w-px animate-bounce bg-foreground-50/50" />
          </div>
        </div>
      </div>
    </section>
  );
}